/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const EditSvg = () => (
  <svg width="1em" height="1em" viewBox="1.5 1.5 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_19_3072)">
      <path d="M2.66663 13.3333H5.33329L12.3333 6.33333C12.6869 5.97971 12.8856 5.50009 12.8856 5C12.8856 4.4999 12.6869 4.02029 12.3333 3.66666C11.9797 3.31304 11.5001 3.11438 11 3.11438C10.4999 3.11438 10.0202 3.31304 9.66663 3.66666L2.66663 10.6667V13.3333Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9 4.33331L11.6667 6.99998" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>
);

export const EditIcon = props => <Icon component={EditSvg} {...props} />;
